import { Component } from "react";
import TalaeraRoutes from "./../../../../../routes/TalaeraRoutes";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link } from "react-router-dom";

export class ReadingListFilter {
  static ASSIGNED_BY_TEACHER = {
    filterName: "reading_assigned_by_teacher",
    name: "Assigned by teacher",
  };
  static SAVED_BY_MYSELF = {
    filterName: "reading_saved_by_myself",
    name: "Saved by myself",
  };
  static ALREADY_READ = {
    filterName: "reading_completed",
    name: "Already read",
  };

  static getAll() {
    return [
      ReadingListFilter.ASSIGNED_BY_TEACHER,
      ReadingListFilter.SAVED_BY_MYSELF,
      ReadingListFilter.ALREADY_READ,
    ];
  }
}

export default class ReadingListSection extends Component {
  render() {
    return (
      <SidePanelSection
        sectionTitle="My Reading List"
        list={ReadingListFilter.getAll()}
        location={this.props.location}
        tagName={ReadingListItem}
      />
    );
  }
}

class ReadingListItem extends Component {
  render() {
    const path = TalaeraRoutes.buildHomeworkPath(this.props.item.filterName);
    return (
      <li className={path === this.props.location.pathname ? "active" : ""}>
        <Link className="btn" to={path}>
          {this.props.item.name}
        </Link>
      </li>
    );
  }
}
